export default function () {
	return {
		init() {
			this.attachEvents()
		},

		attachEvents() {
			this.$refs.quantityInput.addEventListener('click', (e) => {
				e.preventDefault()
			})

			this.$refs.decrementQuantityTrigger.addEventListener('click', (e) => {
				this.decrementQuantity(e)
			})

			this.$refs.incrementQuantityTrigger.addEventListener('click', (e) => {
				this.incrementQuantity(e)
			})
		},

		decrementQuantity(e) {
			e.preventDefault()

			const quantity = Number.parseInt(this.$refs.quantityInput.value)
			const min = Number.parseInt(this.$refs.quantityInput.min)

			if (!Number.isNaN(min) && quantity <= min) {
				return
			}

			this.$refs.quantityInput.value = quantity - 1
			this.$refs.quantityInput.dispatchEvent(new Event('input', { bubbles: true }))
		},

		incrementQuantity(e) {
			e.preventDefault()

			const quantity = Number.parseInt(this.$refs.quantityInput.value)
			const max = Number.parseInt(this.$refs.quantityInput.max)

			if (!Number.isNaN(max) && quantity >= max) {
				return
			}

			this.$refs.quantityInput.value = quantity + 1
			this.$refs.quantityInput.dispatchEvent(new Event('input', { bubbles: true }))
		},
	}
}
